import React from "react";
import { Link } from "react-router";
import styled from "styled-components";
import { Card, Muted } from "./ui";

const NotFoundCard = styled(Card)`
  display: grid;
  gap: 0.85rem;
`;

const BackLink = styled(Link)`
  width: fit-content;
  color: #2563eb;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const NotFoundPage: React.FC = () => (
  <NotFoundCard>
    <Muted>
      We couldn&rsquo;t find that LaceAI page. Check the address or return to your workout workspace.
    </Muted>
    <BackLink to="/generate">Go to Generate</BackLink>
  </NotFoundCard>
);

export default NotFoundPage;
